//统一管理咱们项目用户相关的接口

import request from "./request";

//项目用户相关的请求地址

const API = {
  getNews: "/apkHistory/getNews",
};
export const getNews = (data) => request.get(API.getNews, data);
